// Element ID's
export const HEADER_ID = 'header_bar';
export const SEARCH_INPUT_ID = 'search-input';
export const SEARCH_RESULTS_ID = 'search-results';
export const SEARCH_RESULTS_CONTENT_SELECTOR = `#${SEARCH_RESULTS_ID} .section-content`;

/**
 * This tab is selected by default when search is being made in search dropdown.
 */
export const INITIAL_ACTIVE_TAB = 'all';

/**
 * Minimum length of the search query to trigger a search.
 */
export const MIN_SEARCH_LENGTH = 2;

/**
 * This event triggers HTMX to fetch search results.
 */
export const FETCH_SEARCH_EVENT_NAME = 'triggerHTMXSearchResults';

/**
 * Recent searches are stored under this key in localStorage.
 */
export const RECENT_SEARCHES_LOCAL_STORAGE_KEY = 'searchHistory';

/**
 * Maximum number of recent searches to display.
 */
export const RECENT_SEARCHES_DISPLAY_LIMIT = 3;
